<!-- Divider -->
<div
    class="ioteq-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
